export const dailySafetyTips = [
  { title: "Check the sky before the screen", text: "Compare the forecast with clouds, gust lines, and visibility before leaving the dock." },
  { title: "Reef before you need to", text: "If gusts are rising, reduce sail early while the crew is calm and the boat is balanced." },
  { title: "Plan one safe exit", text: "Before departure, name the nearest marina, anchorage, or turn-back point for today’s route." },
  { title: "Brief the crew in one minute", text: "Show everyone lifejackets, radio basics, man-overboard action, and where to sit in rough water." },
  { title: "Watch the gust gap", text: "When gusts are much stronger than average wind, expect sudden heel and slower reactions." },
  { title: "Visibility changes the plan", text: "Poor visibility increases collision risk. Slow down, show lights, and keep a proper lookout." },
  { title: "Respect wave period", text: "Short, steep waves can feel worse than taller long-period swell, especially near shore." },
];

export function todaySafetyTip() {
  const day = Math.floor(Date.now() / 86400000);
  return dailySafetyTips[day % dailySafetyTips.length];
}

export function calculateDailySailing(weather) {
  const forecast = weather?.forecast;
  const marine = weather?.marine;
  const wind = Number(forecast?.current?.wind_speed_10m ?? 0);
  const gust = Number(forecast?.current?.wind_gusts_10m ?? wind);
  const rain = Number(forecast?.current?.precipitation ?? 0);
  const visibilityKm = Number(forecast?.current?.visibility ?? 10000) / 1000;
  const wave = Number(marine?.current?.wave_height ?? 0);
  const current = Number(marine?.hourly?.ocean_current_velocity?.[0] ?? 0);

  const windScore = Math.max(0, 100 - Math.max(0, wind - 8) * 4 - Math.max(0, gust - 18) * 2);
  const waveScore = Math.max(0, 100 - wave * 28);
  const visibilityScore = Math.min(100, visibilityKm * 12);
  const rainScore = Math.max(0, 100 - rain * 45);
  const tideScore = Math.max(40, 100 - current * 22);
  const score = Math.round((windScore * 0.28) + (waveScore * 0.24) + (visibilityScore * 0.18) + (rainScore * 0.16) + (tideScore * 0.14));
  const level = score >= 80 ? "Ideal" : score >= 62 ? "Good" : score >= 42 ? "Risky" : "Stay in port";
  return { score, level, wind, gust, wave, visibilityKm, rain, tideScore };
}

export function routeRecommendation(location, summary) {
  const safeDistance = summary.score >= 80 ? 14 : summary.score >= 62 ? 8 : summary.score >= 42 ? 4 : 0;
  const status = safeDistance ? "Recommended" : "Not recommended";
  const boatNote = summary.wind > 18 || summary.wave > 1.4 ? "Best for experienced skippers or larger boats." : "Suitable for a relaxed short coastal sail.";
  return {
    status,
    title: safeDistance ? `${safeDistance} NM coastal practice loop` : "Harbor checks and safety review",
    text: safeDistance ? `Start near ${location?.city || "your coast"}, stay within easy return range, and keep one sheltered fallback.` : "Conditions are not friendly enough for a daily route suggestion today.",
    boatNote,
  };
}